// extracted by mini-css-extract-plugin
export default {"root":"DishesDeleteModal_root__9j4Q3","describe":"DishesDeleteModal_describe__WzdXY","placeHolderShimmer":"DishesDeleteModal_placeHolderShimmer__JCosw"};